import React from "react";
import {Avatar, Col, Row} from "antd";
import Highlighter from "react-highlight-words";

type Entity = {
  id: string,
  code: string,
  members: string,
  title: string,
  description: string,
  typeEntity: string

}

type ResultProps = {
  entity: Entity,
  match: string
}


function ResultEntity(props: ResultProps) {
  return (
    <Row gutter={[8, 0]} wrap={false}>
      <Col flex={"none"} className={"gt-d-flex-center"}>
        <Avatar className={"giro-user-avatar gt-font-weight-700"}
                shape={"square"}>{(props.entity.typeEntity).substring(0, 2)}</Avatar>
      </Col>
      <Col flex={"auto"} className={"gt-text-overflow-ellipsis"}>
        <Highlighter
          searchWords={props.match.split(" ")}
          autoEscape={true}
          textToHighlight={props.entity.title}
        />
        <div className={"giro-fs-12"}>
          <Highlighter
            searchWords={props.match.split(" ")}
            autoEscape={true}
            textToHighlight={props.entity.title}
          />
        </div>
      </Col>
      <Col span={3}>
        <Highlighter
          searchWords={props.match.split(" ")}
          autoEscape={true}
          textToHighlight={props.entity.code}
        />
      </Col>
    </Row>
  );
}

export default ResultEntity;
